import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '40px 20px'
    }}>
      <div style={{
        maxWidth: '900px',
        margin: '0 auto',
        background: '#FFFFFF',
        padding: '40px',
        border: '4px solid #333333',
        boxShadow: '8px 8px 0px rgba(0, 0, 0, 0.3)'
      }}>
        <h1 style={{
          margin: '0 0 12px 0',
          fontSize: '2.5rem',
          fontWeight: '900',
          color: '#333333',
          textTransform: 'uppercase',
          letterSpacing: '0.05em'
        }}>
          Terms of Service
        </h1>

        <p style={{
          margin: '0 0 32px 0',
          fontSize: '0.95rem',
          color: '#666666',
          fontStyle: 'italic'
        }}>
          Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>

        <div style={{
          padding: '20px',
          background: '#fff3cd',
          border: '2px solid #ffc107',
          borderRadius: '4px',
          marginBottom: '32px'
        }}>
          <p style={{
            margin: '0',
            fontSize: '1rem',
            color: '#856404',
            fontWeight: '600',
            lineHeight: '1.6'
          }}>
            <strong>Important Notice:</strong> This is an educational investment simulation platform.
            No real money is involved. Nothing on this platform constitutes financial advice.
          </p>
        </div>

        {/* Section 1 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            1. Service Description
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', marginBottom: '12px' }}>
            This platform ("the Service") is an <strong>educational stock market simulator</strong> designed
            to teach investment concepts in a risk-free environment.
          </p>
          <ul style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', paddingLeft: '24px' }}>
            <li>All trading uses <strong>virtual currency only</strong> - no real money is involved</li>
            <li>Market data is provided for educational purposes</li>
            <li>The AI guide provides educational content, not investment advice</li>
            <li>Portfolios, trades, and performance are simulated</li>
          </ul>
        </section>

        {/* Section 2 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            2. Not Investment Advice
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', marginBottom: '12px' }}>
            <strong>The Service does NOT provide investment, financial, legal, or tax advice.</strong>
          </p>
          <ul style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', paddingLeft: '24px' }}>
            <li>All content is for <strong>educational purposes only</strong></li>
            <li>The AI guide provides general information about investing concepts, not personalized recommendations</li>
            <li>Simulated performance does not guarantee real-world results</li>
            <li>Before making real investment decisions, consult a licensed financial advisor</li>
            <li>We are not registered as a broker-dealer, investment advisor, or financial planner</li>
          </ul>
        </section>

        {/* Section 3 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            3. Age Requirement
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444' }}>
            You must be <strong>16 years of age or older</strong> to use this Service.
            By creating an account, you confirm that you meet this age requirement.
          </p>
        </section>

        {/* Section 4 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            4. Data Usage
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', marginBottom: '12px' }}>
            We collect and use data to improve your educational experience:
          </p>
          <ul style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', paddingLeft: '24px' }}>
            <li>Your portfolio choices and simulated trades</li>
            <li>Platform usage and interaction patterns</li>
            <li>Questions asked to the AI guide</li>
            <li>Account information (email, name, date of birth)</li>
          </ul>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', marginTop: '12px' }}>
            See our <Link to="/privacy" style={{ color: '#1976d2', textDecoration: 'underline', fontWeight: '600' }}>Privacy Policy</Link> for full details.
          </p>
        </section>

        {/* Section 5 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            5. Limitation of Liability
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', marginBottom: '12px' }}>
            <strong>We are NOT responsible for:</strong>
          </p>
          <ul style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', paddingLeft: '24px' }}>
            <li>Real investment decisions you make based on this simulation</li>
            <li>Financial losses incurred in real markets</li>
            <li>Accuracy or completeness of market data provided</li>
            <li>Service interruptions or technical issues</li>
            <li>AI-generated content errors or misunderstandings</li>
          </ul>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', marginTop: '12px' }}>
            THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND.
          </p>
        </section>

        {/* Section 6 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            6. Indemnification
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444' }}>
            You agree to indemnify and hold us harmless from any claims, losses, or damages arising from:
          </p>
          <ul style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', paddingLeft: '24px' }}>
            <li>Your use of the Service</li>
            <li>Real investment decisions you make</li>
            <li>Violation of these Terms</li>
            <li>Violation of any third-party rights</li>
          </ul>
        </section>

        {/* Section 7 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            7. Account Responsibilities
          </h2>
          <ul style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', paddingLeft: '24px' }}>
            <li>You are responsible for maintaining account security</li>
            <li>You must provide accurate information</li>
            <li>You may not share your account with others</li>
            <li>We reserve the right to suspend or terminate accounts for violations</li>
          </ul>
        </section>

        {/* Section 8 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            8. Prohibited Uses
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', marginBottom: '12px' }}>
            You may NOT:
          </p>
          <ul style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444', paddingLeft: '24px' }}>
            <li>Attempt to hack, disrupt, or compromise the Service</li>
            <li>Use automated tools to access the Service without permission</li>
            <li>Misrepresent yourself or your age</li>
            <li>Use the Service for any illegal purpose</li>
            <li>Scrape or extract data without authorization</li>
          </ul>
        </section>

        {/* Section 9 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            9. Modifications to Terms
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444' }}>
            We reserve the right to modify these Terms at any time.
            Continued use of the Service after changes constitutes acceptance of the new Terms.
            We will notify users of material changes via email or platform notification.
          </p>
        </section>

        {/* Section 10 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            10. Governing Law
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444' }}>
            These Terms are governed by the laws of Israel.
            Any disputes shall be resolved in the competent courts of Israel.
          </p>
        </section>

        {/* Section 11 */}
        <section style={{ marginBottom: '32px' }}>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#333333',
            marginBottom: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em'
          }}>
            11. Contact Information
          </h2>
          <p style={{ fontSize: '1rem', lineHeight: '1.7', color: '#444444' }}>
            If you have questions about these Terms, please contact us at:{' '}
            <a href="mailto:support@example.com" style={{ color: '#1976d2', textDecoration: 'underline', fontWeight: '600' }}>
              support@example.com
            </a>
          </p>
        </section>

        {/* Back Button */}
        <div style={{ marginTop: '40px', textAlign: 'center' }}>
          <Link
            to="/"
            style={{
              display: 'inline-block',
              padding: '14px 32px',
              fontSize: '1.1rem',
              fontWeight: '900',
              color: '#FFFFFF',
              background: '#667eea',
              border: '3px solid #333333',
              boxShadow: '4px 4px 0px #333333',
              textDecoration: 'none',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              transition: 'all 0.2s ease'
            }}
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
